import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router";
import { GoHome } from "react-icons/go";
import { GrPower } from "react-icons/gr";
// import { FaChevronDown } from "react-icons/fa";
// import { RiArrowDropRightLine } from "react-icons/ri";
import { ROUTES } from "@routes/RouteConstant";
import fisLogo from "@assets/images/fis-logo.svg";
import { PiBuildingOfficeBold } from "react-icons/pi";
import { LuMonitorCog, LuUserRoundCog } from "react-icons/lu";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import useEUMSPermission from "@hooks/useEUMSPermission";
import { logout } from "@services/userModule/UserService";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@store/store";
import { setAuthenticated } from "@redux/auth/auth";
import { setTokenData } from "@redux/auth/tokenData";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);

  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const toggleDropdown = (menu: string) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const { hasGetAllPermission: hasGetAllPermissionCompany } =
    useEUMSPermission("COMPANY");
  const { hasGetAllPermission: hasGetAllPermissionService } =
    useEUMSPermission("SERVICE");
  const { hasGetAllPermission: hasGetAllPermissionServiceEndpoint } =
    useEUMSPermission("SERVICEENDPOINT");
  const { hasGetAllPermission: hasGetAllPermissionUserGroup } =
    useEUMSPermission("USERGROUP");
  const { hasGetAllPermission: hasGetAllPermissionUser } =
    useEUMSPermission("USER");

  const handleLogout = () => {
    logout().then(() => {});
    dispatch(
      setTokenData({
        token: "",
        tokenexpires: "",
        portalProtected: false,
      }),
    );
    dispatch(setAuthenticated(false));
    navigate(ROUTES.LOGIN, { replace: true });
  };
  return (
    <aside
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      aria-label="Main Sidebar"
    >
      <div className="brand">
        <img src={fisLogo} alt="logo full" className="logo logo-full" />
        <img src={fisLogo} alt="logo small" className="logo logo-sm" />
      </div>

      <div className="menu-wrapper">
        <nav className="menu">
          <NavLink className="menu-item" to={ROUTES.DASHBOARD}>
            <GoHome className="icon" />
            <span className="label">Home</span>
          </NavLink>
          {hasGetAllPermissionCompany && (
            <NavLink className="menu-item" to={ROUTES.COMPANY_MANAGEMENT}>
              <PiBuildingOfficeBold className="icon" />
              <span className="label">Company Management</span>
            </NavLink>
          )}
          {/* <NavLink className="menu-item" to="/service-management">
            <LuMonitorCog className="icon" />
            <span className="label">Service Management</span>
          </NavLink> */}
          {(hasGetAllPermissionService ||
            hasGetAllPermissionServiceEndpoint) && (
            <NavLink className="menu-item" to={ROUTES.PRODUCT_MANAGEMENT}>
              <LuMonitorCog className="icon" />
              <span className="label">Product Management</span>
            </NavLink>
          )}
          {hasGetAllPermissionUserGroup && (
            <NavLink className="menu-item" to={ROUTES.USER_GROUP}>
              <AiOutlineUsergroupAdd className="icon" />
              <span className="label">User Group</span>
            </NavLink>
          )}

          {hasGetAllPermissionUser && (
            <NavLink className="menu-item" to={ROUTES.USERS}>
              <LuUserRoundCog className="icon" />
              <span className="label">Users</span>
            </NavLink>
          )}
          {/* <button
            className={`dropdown-menu-wrapper ${
              openDropdown === "userManagement" ? "open" : ""
            }`}
            onClick={() => toggleDropdown("userManagement")}
          >
            <div className={`menu-item flex-column`}>
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="d-flex align-items-center gap-3">
                  <LuUserRoundCog className="icon" />
                  <span className="label">User Management</span>
                </div>
                <FaChevronDown className="chevron" />
              </div>
            </div>
            <div className={"sub-menu"}>
              <NavLink to="/submenu-1" className="submenu-item">
                <RiArrowDropRightLine size={24} />
                Sub Menu 1
              </NavLink>
              <NavLink to="/submenu-2" className="submenu-item">
                <RiArrowDropRightLine size={24} />
                Sub Menu 2
              </NavLink>
              <NavLink to="/submenu-2" className="submenu-item">
                <RiArrowDropRightLine size={24} />
                Sub Menu 3
              </NavLink>
            </div>
          </button> */}
        </nav>
      </div>

      <div className="sidebar-footer">
        <nav className="menu">
          <NavLink
            className="menu-item logout-menu"
            to={"#"}
            onClick={handleLogout}
          >
            <GrPower className="icon" />
            <span className="label">Logout</span>
          </NavLink>
        </nav>
      </div>
    </aside>
  );
};
export default Sidebar;
